namespace Areas.Projects {
    "use strict";

    let formCrudOps: FormCrudOperations;
    $(() => { init(); });

    function init() {
        formCrudOps = new FormCrudOperations("Projects");
    }

    export function insertRecord(e: any) {
        if (continueEvenIfMissingSubAccount()) {
            formCrudOps.insertRecord();
        }
    }

    export function updateRecord(e: any) {
        if (continueEvenIfMissingSubAccount()) {
            formCrudOps.updateRecord();
        }
    }

    export function deleteRecord() {
        formCrudOps.deleteRecord();
    }

    function continueEvenIfMissingSubAccount(): boolean {
        const data = formCrudOps.form.option("formData");

        if (data.SubAccountId == null)
        {
            if (data.ProjectNumber.startsWith("90")
                || data.ProjectNumber.startsWith("94")) {
                const confirmed = confirm("The Project # starts with 94 or 90 but no Sub Account Id has been set. Do you wish to continue?");
                return confirmed;
            }
        }

        return true;
    }
}

